import { render } from "./CleanupPage.vue?vue&type=template&id=55470b0c&scoped=true"
import script from "./CleanupPage.vue?vue&type=script&lang=js"
export * from "./CleanupPage.vue?vue&type=script&lang=js"

import "./CleanupPage.vue?vue&type=style&index=0&id=55470b0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55470b0c"]])

export default __exports__